import { LandingDesktop } from "./Landing-desktop";

export const Landing = () => {
  return <LandingDesktop />;
};
